import styled from 'styled-components';
import tw from 'twin.macro';

import { colors as Colors } from '@nw/shared/ui';

export const TileFieldContainer = styled.div<{
  isHidden?: boolean;
  isMarginBottomZero?: boolean;
}>`
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  width: 100%;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  ${(props) => (props.isMarginBottomZero ? tw`mb-0` : tw`mb-4`)};
`;

export const TileOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 12px;
  box-sizing: border-box;
`;

export const TileOptionButton = styled.button<{
  isSelected: boolean;
  $selectedBg: string;
  $selectedBorder: string;
  $defaultBg: string;
  $defaultBorder: string;
  $textColor: string;
}>`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  text-align: center;
  white-space: nowrap;
  border: 1px solid
    ${(p) => (p.isSelected ? p.$selectedBorder : p.$defaultBorder)};
  background-color: ${(p) =>
    p.isSelected ? p.$selectedBg : p.$defaultBg};
  color: ${(p) => p.$textColor};
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

export const TileSelectErrorText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${Colors['light-rose-700']};
  min-height: 16px;
  box-sizing: border-box;
`;
